export default __webpack_public_path__ + "static/media/F0003.13fd3123.png";